import * as React from 'react';
import { FC } from 'react';

import styled, { keyframes } from 'styled-components';

interface IProgressMeter {
  percentage: number;
}

const Wrapper = styled.div`
  width: 100%;
  height: 0.5rem;
  border-radius: 0.625rem;
  border: 1px solid ${Styles.color.grey.four};
  background-color: ${Styles.color.grey.four};
`;

const fillMeter = ({ percentage }: { percentage: number }) => keyframes`
  to {
    width: ${`${percentage}%`}
  }
`;

const Progress = styled.div<{ percentage: number }>`
  width: 0%;
  transition: 0.25s;
  height: 100%;
  border-radius: inherit;
  background-color: ${Styles.color.primary};
  animation: ${fillMeter} 0.75s 0.25s forwards;
`;

const ProgressMeter: FC<IProgressMeter> = ({ percentage, ...props }) => {
  return (
    <Wrapper {...props}>
      <Progress
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percentage}
        percentage={percentage}
      />
    </Wrapper>
  );
};

export default ProgressMeter;
